import React from 'react';
import {DataEditorModalProps} from '../../types';

interface ExtendedDataEditorModalProps extends DataEditorModalProps {
    selectedAgent?: string; // Add selectedAgent prop
    onAgentFilterChange?: (agent: string) => void; // Add agent filter handler
}

const DataEditorModal: React.FC<ExtendedDataEditorModalProps> = ({
                                                                     isOpen,
                                                                     onClose,
                                                                     editableData,
                                                                     setEditableData,
                                                                     onSaveChanges,
                                                                     selectedAgent,
                                                                     onAgentFilterChange
                                                                 }) => {
    if (!isOpen || !editableData) return null;

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content data-editor-modal" onClick={(e) => e.stopPropagation()}>
                {/* Modal Header with Agent Filter */}
                <div className="modal-header" style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: '1rem'
                }}>
                    <h2> Test Data Editor: {editableData.name}</h2>
                    <div style={{display: 'flex', gap: '1rem', alignItems: 'center'}}>
                        <label>
                            Agent:
                            <select
                                value={selectedAgent || 'all'}
                                onChange={(e) => onAgentFilterChange && onAgentFilterChange(e.target.value)}
                                style={{marginLeft: '0.5rem', padding: '0.25rem'}}
                            >
                                <option value="all">All Agents</option>
                                {/* Add other agents dynamically */}
                            </select>
                        </label>
                        <button className="pushable push-secondary btn-sm" onClick={onClose}>
                            <span className="shadow"></span>
                            <span className="edge"></span>
                            <span className="front">✕</span>
                        </button>
                    </div>
                </div>

                <div className="control-group">
                    <label>Task Prompt</label>
                    <textarea
                        value={editableData.task_prompt}
                        onChange={e => setEditableData({...editableData, task_prompt: e.target.value})}
                        rows={3}
                        style={{width: '100%', padding: '0.5rem', borderRadius: '4px', border: '1px solid #ddd'}}
                        placeholder="Enter the customer request or scenario..."
                    />
                </div>

                <div className="control-group">
                    <label>Mock Data (JSON)</label>
                    <textarea
                        value={JSON.stringify(editableData.mock_data, null, 2)}
                        onChange={e => {
                            try {
                                setEditableData({...editableData, mock_data: JSON.parse(e.target.value)})
                            } catch (err) {
                                //console.log("Invalid JSON");
                            }
                        }}
                        rows={10}
                        style={{
                            width: '100%',
                            padding: '0.5rem',
                            borderRadius: '4px',
                            border: '1px solid #ddd',
                            fontFamily: 'monospace'
                        }}
                        placeholder="Enter mock data as JSON..."
                    />
                </div>

                <div className="control-group">
                    <label>Expected Outcome</label>
                    <textarea
                        value={editableData.expected_outcome}
                        onChange={e => setEditableData({...editableData, expected_outcome: e.target.value})}
                        rows={3}
                        style={{width: '100%', padding: '0.5rem', borderRadius: '4px', border: '1px solid #ddd'}}
                        placeholder="Describe what the agent should do..."
                    />
                </div>

                <div className="modal-actions">
                    <button className="pushable push-secondary" onClick={onClose}>
                        <span className="shadow"></span>
                        <span className="edge"></span>
                        <span className="front">Cancel</span>
                    </button>
                    <button className="pushable push-success" onClick={onSaveChanges}>
                        <span className="shadow"></span>
                        <span className="edge"></span>
                        <span className="front">Save Changes</span>
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DataEditorModal;